import * as React from 'react';
import {Translate} from '../../../../../../shared/LanguageService';
import {
    getSupportedContentProvidersForManualConnection,
    hasInvalidObjectIdFormatForContentProvider,
} from '../../../../../../shared/ContentProvider';
import {useSaveBrokerSystemConnectionMutation} from './queries/connectBrokerSystemMutation';

interface IUseBrokerSystemModalProps {
    orderId: number;
    brokerFirmContentProviderId?: number;
    onHide: () => void;
    onSaveSuccess: () => Promise<any>;
    onSaveResult: (success: boolean) => void;
}

export function useBrokerSystemModal({orderId, brokerFirmContentProviderId, onHide, onSaveSuccess, onSaveResult}: IUseBrokerSystemModalProps) {
    const [selectedBrokerSystem, setSelectedBrokerSystem] = React.useState<number | null>(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const [objectId, setObjectId] = React.useState('');

    const activeBrokerSystemId = brokerFirmContentProviderId || selectedBrokerSystem;
    const supportedProviders = getSupportedContentProvidersForManualConnection();
    const showHelpSection = activeBrokerSystemId != null && supportedProviders.some(p => p.id === activeBrokerSystemId);
    const trimmedObjectId = objectId.trim();
    const hasInvalidObjectIdFormat = hasInvalidObjectIdFormatForContentProvider(activeBrokerSystemId, trimmedObjectId);
    const objectIdValidationMessage = hasInvalidObjectIdFormat
        ? Translate('view-order/basic-order-info/modal/object-id-validation-error')
        : '';
    const isSaveDisabled = !trimmedObjectId || (!brokerFirmContentProviderId && !selectedBrokerSystem) || hasInvalidObjectIdFormat;

    const saveBrokerSystemConnection = useSaveBrokerSystemConnectionMutation(orderId);

    const handleSave = async () => {
        setIsLoading(true);
        try {
            const result = await saveBrokerSystemConnection(trimmedObjectId, activeBrokerSystemId as number);
            if (result === true) {
                onHide();
                onSaveResult(true);
                await onSaveSuccess();
            } else {
                onHide();
                onSaveResult(false);
            }
        } catch (e) {
            onHide();
            onSaveResult(false);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        selectedBrokerSystem,
        setSelectedBrokerSystem,
        objectId,
        setObjectId,
        isLoading,
        activeBrokerSystemId,
        showHelpSection,
        isSaveDisabled,
        hasInvalidObjectIdFormat,
        objectIdValidationMessage,
        handleSave,
    };
}
